import script from "./otherForm.vue?vue&type=script&setup=true&lang=js"
export * from "./otherForm.vue?vue&type=script&setup=true&lang=js"

import "./otherForm.vue?vue&type=style&index=0&id=b753a72e&lang=scss&scoped=true"

import exportComponent from "/var/www/ddup_czb/slczb_app_web/view/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b753a72e"]])

export default __exports__